import { render, staticRenderFns } from "./SuggestedCreators.vue?vue&type=template&id=63d13e22&scoped=true&"
import script from "./SuggestedCreators.vue?vue&type=script&lang=ts&"
export * from "./SuggestedCreators.vue?vue&type=script&lang=ts&"
import style0 from "swiper/css/swiper.css?vue&type=style&index=0&id=63d13e22&scoped=true&lang=css&"
import style1 from "./SuggestedCreators.vue?vue&type=style&index=1&id=63d13e22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d13e22",
  null
  
)

export default component.exports